export enum AuctionOfferStatusEnum {
  Won = 'won',
  Submitted = 'submitted',
  Outbid = 'outbid',
  Accepted = 'accepted',
  Rejected = 'rejected'
}
